
import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

import Spinner from '../Spinner/index.jsx';


const NO_LIMIT_PAGE_SIZE = -1;


/**
 * A higher-order component used to wrap components, implementing the common
 * functionality used when retrieving paginated data from an API.
 */
export default function(Component, apiService) {
  var responsePaginationLimit = 0;

  if (apiService && apiService.pageSize) {
    responsePaginationLimit = apiService.pageSize;
  }

  class WrappedComponent extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        fetching: false,
        page: 1,
        canPage: false,
        hasData: false,
        articles: [],
        error: undefined
      };

      this.fetchPage = this.fetchPage.bind(this);
      this.fetchComplete = this.fetchComplete.bind(this);
      this.fetchError = this.fetchError.bind(this);
      this.reset = this.reset.bind(this);
    }

    fetchPage() {
      if (! this.state.fetching) {
        this.setState({ fetching: true });

        apiService.fetchPage(this.state.page)
          .then(this.fetchComplete, this.fetchError);
      }
    }

    fetchComplete(response) {
      this.setState(function(oldState) {
        const articlesToAdd = response?.articles || response;
        const newArticles = oldState.articles.concat(articlesToAdd);
        const totalArticlesCount = response?.count || 0;

        return {
          articles: newArticles,
          canPage: articlesToAdd.length >= (responsePaginationLimit - 1) && responsePaginationLimit !== NO_LIMIT_PAGE_SIZE,
          hasData: totalArticlesCount === 0 ? true : newArticles.length < totalArticlesCount,
          page: (oldState.page + 1),
          fetching: false
        };
      });
    }

    fetchError(error) {
      this.setState({ error: error, fetching: false });
    }

    /**
     * Reset this wrapper, and start from the beginning.
     */
    reset() {
      this.setState({
        page: 1,
        canPage: false,
        hasData: false,
        articles: [],
        error: undefined
      }, this.fetchPage);
    }

    componentDidMount() {
      this.fetchPage();

      if (apiService.addChangeListener) {
        apiService.addChangeListener(this.reset);
      }
    }

    componentWillUnmount() {
      if (apiService.removeChangeListener) {
        apiService.removeChangeListener(this.reset);
      }
    }

    render() {
      const results = [];

      if (this.state.error) {
        results.push(
          <Alert key="error" variant="danger">
            <strong>Error:</strong> {this.state.error.toString()}
          </Alert>
        );
      } else {
        results.push(
          <Component key="component" articles={this.state.articles} fetching={this.state.fetching} {...this.props} />
        );
        if (this.state.fetching) {
          results.push(
            <div key="loading" className="my-4">
              <Spinner />
            </div>
          );
        }
        if (this.state.canPage) {
          if (this.state.hasData) {
            results.push(
              <div key="load-more" className="my-4 text-center">
                <Button disabled={this.state.fetching} onClick={this.fetchPage}>Load More</Button>
              </div>
            );
          }
        }
      }

      return results;
    }
  };


  return WrappedComponent;
};

